import "./scss/index.scss";
import { RichText } from "prismic-reactjs";
import React from "react";
export function InstagramHeader(_ref) {
  var title = _ref.title,
      json_title = _ref.json_title,
      user_name = _ref.user_name,
      text = _ref.text;
  return React.createElement("div", {
    className: "instagram-header"
  }, React.createElement("div", {
    className: "instagram-header-title"
  }, React.createElement(RichText, {
    render: title || json_title
  })), React.createElement("div", {
    className: "instagram-header-link"
  }, React.createElement("a", {
    href: "https://www.instagram.com/renodoors/",
    target: "_blank",
    rel: "noreferrer"
  }, React.createElement(RichText, {
    render: user_name
  }))), React.createElement("div", {
    className: "instagram-header-hint"
  }, React.createElement(RichText, {
    render: text
  })));
}